module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-controls-wrapper"
  }, [_c('color-legend', {
    staticClass: "compare-scale",
    attrs: {
      "orientation": 'horizontal'
    }
  }), _vm._v(" "), _c('scale-toggle', {
    staticClass: "compare-toggle",
    attrs: {
      "grayscale": _vm.grayscale,
      "toggleScale": _vm.toggleScale
    }
  }), _vm._v(" "), _c('download-button')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c442aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/CurrentControls.vue
// module id = 537
// module chunks = 1